import React from 'react';

const DisplayLineAndStage = ({ pipeline, pipelineStage }) => {
    return (
        <div className='display-line-and-stage'>
            {pipeline.name}
            <div className='oi oi-chevron-right' style={{ fontSize: 'x-small', padding: '2px 8px 0 8px' }} />
            {pipelineStage.name}
        </div>
    );
};

export default DisplayLineAndStage;
